import { ExpandableRowData, Ticket } from '@types'

const prepareDataToExpandableTable = (data?: Ticket[]) =>
  data?.reduce((acc, ticket) => {
    const withdrawalDay = ticket.withdrawalDay as string
    const group = acc.find(item => item.key === withdrawalDay)
    if (group) {
      group.tickets.push(ticket)
    } else {
      acc.push({ key: withdrawalDay, tickets: [ticket] })
    }
    return acc
  }, [] as ExpandableRowData[])

export default prepareDataToExpandableTable
